import {  faFileCircleCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import PulseLoader from "react-spinners/PulseLoader";
import { useAddNewUploadMutation } from '../features/uploads/uploadApiSlice';
import getFilePath from "../utils/getFilePath"

function ResponseFile({action, body, setBody}) {
  const [selectedFile, setSelectedFile] = useState();
  const inputRef = useRef(null);
  //const [isSelected, setIsSelected] = useState(false);
  
  
    useEffect(() => {

      if (selectedFile) {
        handleSubmission()
      }

  }, [selectedFile])
  
    const [upload, {
          isLoading,
          isSuccess,
          isError,
          error,
          data
      }] = useAddNewUploadMutation()
      useEffect(() => {
        if (isSuccess && ( data.location || data.webLocation)) {
          setBody({location:data.location||'', name:data.name, webLocation:data.webLocation || ''})
          setSelectedFile('')
          inputRef.current.value = null;
        }
    
    }, [isSuccess])
    const errClass = (isError ) ? "errmsg" : "offscreen"
    const errContent = (error?.data?.message ) ?? ''
    const changeHandler = (event) => {
      setSelectedFile(event.target.files[0]);
      //setIsSelected(true);
    }

    const handleSubmission = async () => {
      const formData = new FormData();
      formData.append('file', selectedFile);
           upload({folderId:action.task,file:formData })
         
          
    }

    const validBodyClass = !body ? "form__input--incomplete" : ''

  return (
    <>
     <p className={errClass}>{errContent}</p>
     <div className={validBodyClass}>
       <div className="form__row">
                <label className="form__label" htmlFor="body">
                {action.title}-{action.text}</label>   
                        </div>
                        <input  ref={inputRef} type="file" name="file" onChange={changeHandler} />
                        {
                        body &&
                         
                          
<a target="_blank"  className="form__title-row form__input--ltr " href={getFilePath(body)}>
<FontAwesomeIcon className="icon-button status--completed" icon={faFileCircleCheck} />

                          <h2 className="status--completed" >
  {body.name}
                          </h2>
                          
                          </a>
                          
                       
                        }
			{/* {isSelected && (
				<div>
					<p>Filename: {selectedFile.name}</p>
					<p>Filetype: {selectedFile.type}</p>
					<p>Size in bytes: {selectedFile.size}</p>
					<p>
						lastModifiedDate:{' '}
						{selectedFile.lastModifiedDate.toLocaleDateString()}
					</p>
				</div>
			) } */}
			<div>
       {(isLoading) && <PulseLoader color={"#FFF"} />}
			</div>
      </div>
    </>
   
  )
}

export default ResponseFile